<div class="terms-of-sale-wrapper">
  <div class="terms-of-sale-container">
    <h1 class="terms-title">{{ "TERMS_OF_SALE_PAGE.TITLE" | translate }}</h1>
    <section>
      <div class="terms-section">
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.INTRO_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.INTRO_2" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.INTRO_3" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.INTRO_4" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.INTRO_5" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.INTRO_6" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.INTRO_7" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.INTRO_8" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.INTRO_9" | translate }}</p>
        <p [innerHTML]="'TERMS_OF_SALE_PAGE.INTRO_10' | translate"></p>
      </div>

      <h1 class="terms-title mt-2">{{ "TERMS_OF_SALE_PAGE.SUBTITLE_1" | translate }}</h1>
      <h1 class="terms-title mt-2">{{ "TERMS_OF_SALE_PAGE.SUBTITLE_2" | translate }}</h1>

      <div class="terms-section">
        <h2 class="terms-heading ml-5"><span class="bold">1. {{ "TERMS_OF_SALE_PAGE.TAB_1" | translate }}</span></h2>
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 1.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_1.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_1.DESC_2" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_1.DESC_3" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 2.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_2.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_2.DESC_2" | translate }}</p>
        <p [innerHTML]="'TERMS_OF_SALE_PAGE.ARTICLE_2.DESC_3' | translate"></p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 3.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_2" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_3" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_4" | translate }}</p>
        <ul>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_5" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_6" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_7" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_8" | translate }}</li>
        </ul>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_9" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 4.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_4.DESC_1" | translate }}</p>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_4.DESC_2" | translate }}</p>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_4.DESC_3" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 5.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_5.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_5.DESC_2" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_5.DESC_3" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 6.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_6.DESC_1" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 7.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_7.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_7.DESC_2" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_7.DESC_3" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_7.DESC_4" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_7.DESC_5" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 8.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_8.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_8.DESC_2" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading ml-5"><span class="bold">2. {{ "TERMS_OF_SALE_PAGE.TAB_2" | translate }}</span></h2>
        <h1 class="terms-title mt-2">{{ "TERMS_OF_SALE_PAGE.SUBTITLE_3" | translate }}</h1>
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 9.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_1" | translate }}</p>
        <ul>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_2" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_3" | translate }}</li>
        </ul>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_4" | translate }}</p>
        <ul>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_5" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_6" | translate }}</li>
        </ul>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_7" | translate }}</p>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_8" | translate }}</p>
        <ul>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_9" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_10" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_11" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_12" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_13" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_14" | translate }}</li>
        </ul>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_15" | translate }}</p>
        <ul>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_16" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_17" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_18" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_19" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_20" | translate }}</li>
        </ul>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_21" | translate }}</p>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_22" | translate }}</p>
      </div>

      <div class="terms-section">
        <h1 class="terms-title mt-2">{{ "TERMS_OF_SALE_PAGE.SUBTITLE_4" | translate }}</h1>
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 10.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_10.DESC_1" | translate }}</p>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_10.DESC_2" | translate }}</p>
      </div>

      <div class="terms-section">
        <h1 class="terms-title mt-2">{{ "TERMS_OF_SALE_PAGE.SUBTITLE_5" | translate }}</h1>
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 11.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_11.DESC_1" | translate }}</p>
        <ul>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_11.DESC_2" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_11.DESC_3" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_11.DESC_4" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_11.DESC_5" | translate }}</li>
        </ul>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_11.DESC_6" | translate }}</p>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_11.DESC_7" | translate }}</p>
      </div>

      <div class="terms-section">
        <h1 class="terms-title mt-2">{{ "TERMS_OF_SALE_PAGE.SUBTITLE_6" | translate }}</h1>
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 12.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_1" | translate }}</p>
        <ul>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_2" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_3" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_4" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_5" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_6" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_7" | translate }}</li>
        </ul>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_8" | translate }}</p>
      </div>

      <div class="terms-section">
        <h1 class="terms-title mt-2">{{ "TERMS_OF_SALE_PAGE.SUBTITLE_7" | translate }}</h1>
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 13.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_13.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_13.DESC_2" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_13.DESC_3" | translate }}</p>
      </div>

      <div class="terms-section">
        <h1 class="terms-title mt-2">{{ "TERMS_OF_SALE_PAGE.SUBTITLE_8" | translate }}</h1>
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 14.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_1" | translate }}</p>
        <ul>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_2" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_3" | translate }}</li>
        </ul>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_6" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_7" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_8" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_9" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_10" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_11" | translate }}</p>
      </div>

      <div class="terms-section">
        <h1 class="terms-title mt-2">{{ "TERMS_OF_SALE_PAGE.SUBTITLE_9" | translate }}</h1>
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 15.</span></h2>
         <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_15.DESC_1" | translate }}</p>
         <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_15.DESC_2" | translate }}</p>
         <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_15.DESC_3" | translate }}</p>
         <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_15.DESC_4" | translate }}</p>
         <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_15.DESC_5" | translate }}</p>
         <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_15.DESC_6" | translate }}</p>
      </div>

      <div class="terms-section">
        <h1 class="terms-title mt-2">{{ "TERMS_OF_SALE_PAGE.SUBTITLE_10" | translate }}</h1>
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 16.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_16.DESC_1" | translate }}</p>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_16.DESC_2" | translate }}</p>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_16.DESC_3" | translate }}</p>
      </div>

      <div class="terms-section">
        <h1 class="terms-title mt-2">{{ "TERMS_OF_SALE_PAGE.SUBTITLE_11" | translate }}</h1>
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 17.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_17.DESC_1" | translate }}</p>
      </div>
    </section>
  </div>
</div>
